import React from 'react'
import ReactDOM from 'react-dom'

import JobApplicationButton from './JobApplicationButton'

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('body.controller--job_offers')) return false
  if (!document.querySelector('body.action--show')) return false

  // for action--show
  document.querySelectorAll('[data-react-job-application-button]').forEach(dom => {
    const props = JSON.parse(dom.dataset.reactJobApplicationButton)
    ReactDOM.render(
      <JobApplicationButton
        jobOfferId={props.job_offer_id}
        jobOfferTitle={props.job_offer_title}
        jobOfferOpen={props.job_offer_open}
      />, dom
    )
  })

  const doc = document.documentElement
  const job_id = document.getElementById('job_id')
  const button_container = document.getElementById('js-job-offer-application-button-container')
  window.addEventListener('scroll', () => {
    if (doc.clientHeight >= job_id.getBoundingClientRect().bottom) {
      button_container.classList.remove('job-offer-application-button-container-fixed')
    } else if (doc.clientHeight < job_id.getBoundingClientRect().bottom) {
      button_container.classList.add('job-offer-application-button-container-fixed')
    }
  })
})
